import { Address } from 'src/models';

function showAddrPart(part?: string) {
  if (part) {
    return `, ${part}`;
  }

  return '';
}

export function formatAddress(address?: Address) {
  if (!address) {
    return '';
  }
  return `${address.street1}${showAddrPart(address.street2)}${showAddrPart(address.city)}${showAddrPart(address.state)}${showAddrPart(address.zip)}`;
}
